import React, { useState } from 'react';
import { ViewSubmittal } from 'records/interactions/ViewSubmittal';
import { Submittal, SubmittalId } from 'records/Submittal';
import withAppStore, { WithAppStoreProps } from 'utils/withAppStore';
import { useTranslator } from '@bluebeam/react-i18n';
import ActionsSidebar from './ActionsSidebar';
import AssignSidebar from './AssignSidebar';
import RespondSidebar from './RespondSidebar';

interface Props extends WithAppStoreProps {
  submittalId: SubmittalId;
}

const SubmittalViewerSidebar = (props: Props) => {
  const [updating, setUpdating] = useState<boolean>(false);

  const { translate } = useTranslator(['buttons']);

  const handleBackClick = () => {
    setUpdating(false);
  };

  const handlePrimaryBtnClick = () => {
    setUpdating(true);
  };

  const handleUpdateSub = () => {
    const { submittalId, appState, actions } = props;

    const submittal = appState.getIn(['submittals', submittalId]) as Submittal;

    const viewSubInteraction = new ViewSubmittal({
      submittal,
    });

    actions.createInteraction(viewSubInteraction);

    actions.clearAllModals();
  };

  const { submittalId, appState } = props;

  const submittal = appState.submittals.get(submittalId, new Submittal());

  const isResponding =
    submittal.status.kind === 'SUB_SUBMITTED_FOR_DESIGN_REVIEW';
  const isAssigning = submittal.status.kind === 'SUB_PENDING_GC_APPROVAL';

  const primaryBtnText = isResponding
    ? translate('buttons:respond')
    : translate('buttons:assign');

  return isResponding || isAssigning ? (
    <>
      {updating && isResponding ? (
        <RespondSidebar
          submittal={submittal}
          onBackClick={handleBackClick}
          onRespond={handleUpdateSub}
        />
      ) : null}
      {updating && isAssigning ? (
        <AssignSidebar
          submittal={submittal}
          onBackClick={handleBackClick}
          onAssign={handleUpdateSub}
        />
      ) : null}
      {!updating ? (
        <ActionsSidebar
          primaryBtnText={primaryBtnText}
          onPrimaryBtnClick={handlePrimaryBtnClick}
        />
      ) : null}
    </>
  ) : null;
};

export default withAppStore<Props>(SubmittalViewerSidebar);
